// @flow
import * as React from 'react';
import type { Element } from 'react';

import type { Photo } from '@screens/Finder/Facility/types';

import { SVGImageFixedAspectRatio } from '@components/SVG';

import { DETAILS_FACILITY } from '@routes';
import { Link, useTranslation } from '@i18n';

import {
  StyledWrapper,
  StyledListItem,
  StyledTextContainer,
  StyledPositionText,
  StyledDepartmentText,
  StyledStartDateText,
  StyledLink,
  StyledImageContainer,
  StyledLocationIcon
} from './styles';

import type { Props } from './types';

const SearchResultFacilityListItem = ({
  result,
  size,
  extractedFacilitiesFromDoctor,
  blogs
}: Props): Element<any> => {
  const { t } = useTranslation('Facilities');

  const {
    slug, name, city, country, number_of_beds, photo_url, photo_alt_tag
  } = result.attributes;
  const companyImages: Array<Photo> = result.relationships?.photos?.data || [];
  const companyHeaderImage = !extractedFacilitiesFromDoctor
    ? companyImages.find(img => img.attributes.kind === 'listing')
    : null;
  const companyHeaderImageUrl = companyHeaderImage?.attributes.photo_url || photo_url || '/images/finder/hospitals.jpg';

  return (
    <StyledWrapper size={size} blogs={blogs}>
      <Link href={DETAILS_FACILITY} params={{ slug }} passHref>
        <StyledLink>
          <StyledListItem>
            <StyledImageContainer>
              <SVGImageFixedAspectRatio
                imageUrl={companyHeaderImageUrl}
                imageAlt={photo_alt_tag || ''}
                imageWidth="533"
                imageHeight="400"
              />
            </StyledImageContainer>
            <StyledTextContainer>
              <StyledPositionText>{name}</StyledPositionText>
              <StyledDepartmentText>
                <StyledLocationIcon />
                {`${city}, ${country}`}
              </StyledDepartmentText>
              <StyledDepartmentText beds>{t('Beds', { number_of_beds })}</StyledDepartmentText>
              <StyledLink startDate>
                {' '}
                <StyledStartDateText>{t('Labels.BookConsultation')}</StyledStartDateText>
              </StyledLink>
            </StyledTextContainer>
          </StyledListItem>
        </StyledLink>
      </Link>
    </StyledWrapper>
  );
};

export default SearchResultFacilityListItem;
